<template>
  <section id="section4">
    <div id="section4-top">
      <div class="wrapper">
        <h1>Wat moet je doen?</h1>
        <div class="row">
          <div class="column" v-for="index in 5" :key="index">
            <h1>{{index}}</h1>
            <h5>{{content[`3.${index}.titel`]}}</h5>
            <p>{{content[`3.${index}.uitleg`]}}</p>
            <div v-if="content[`3.${index}.speelduur`]">{{content[`3.${index}.speelduur`]}}</div>
          </div>
        </div>
      </div>
      <div>
        <arrow-button direction="down" v-scroll-to="'#section4-bottom'" />
      </div>
    </div>
    <div id="section4-bottom">
      <div class="wrapper">
        <div class="row">
          <div class="column">
            <h4>{{content['4.1.titel']}}</h4>
            <Radio ref="groupLevel"
              :options="[content['4.1.1'], content['4.1.2']]" />
          </div>
          <div class="column">
            <h4>{{content['4.2.titel']}}</h4>
            <Radio ref="newGame"
              :options="[content['4.2.1'], content['4.2.2']]" />
          </div>
        </div>
        <div class="footnote">
          {{content['4.1.uitleg-spel']}}
        </div>
      </div>
    </div>
    <div class="clock"><img src="../../assets/images/clock.png"/></div>
    <div class="splash"><img src="../../assets/images/speelWolk.svg"/></div>
    <div class="start-game">
      <v-button :arrow="true" @click="startGame">
        {{content['4.startknop']}}
      </v-button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import content from '@/content/website.json'
import Button from '@/components/Button.vue'
import ArrowButton from '@/components/home/ArrowButton.vue'
import Radio from '@/components/home/RadioButtons.vue'

export default {
  name: 'Section4',
  components: {
    'v-button': Button,
    ArrowButton,
    Radio
  },
  data () {
    return {
      content
    }
  },
  methods: {
    ...mapActions([
      'init'
    ]),
    startGame () {
      const { groupLevel, newGame } = this.$refs
      const level = [56, 78][groupLevel.selected]
      const resume = newGame.selected === 1
      this.init({ level, resume })
      this.$router.push('/game')
    }
  }
}
</script>

<style scoped lang="scss">
#section4 {
  position: relative;
}

#section4-top {
  position: relative;
  height: 144rem;
  padding: 9rem 9rem;
  background-color: $color-orange;

  h1 {
    margin-bottom: 6rem;
    text-align: center;
    color: $color-white;
  }

  .column {
    padding: 0 2.4rem;
    border-right: .1rem solid $color-white;

    &:last-child {
      border: none;
    }

    h1 {
      font-size: 6.0rem;
      font-weight: 900;
    }

    h5 {
      color: $color-white;
      text-transform: none;
      min-height: 7.2rem;
    }
  }

  > div:last-child {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;

    button.arrow {
      background-color: $color-yellow;

      &:hover {
        background-color: lighten($color-yellow, 5%);
      }
    }
  }
}

#section4-bottom {
  padding: 24rem 12rem 6rem 12rem;
  background-color: $color-dark-orange;

  .row {
    padding: 3rem;
    color: $color-black;
    background-color: $color-white;
  }

  .column {
    padding: 0 6rem;

    &:first-child {
      border-right: .1rem solid $color-gray;
    }

    h4 {
      text-transform: none;
    }
  }
}

.wrapper {
  max-width: 120rem;
  margin: 0 auto;
}

.footnote {
  padding: 3rem 0 3rem calc(50% + 3rem);
  text-align: center;
  color: $color-white;
}

.clock {
  position: absolute;
  top: 87rem;
  left: 15%;
  width: 20%;
}

.splash {
  position: absolute;
  top: 150rem;
  left: 50%;
  width: 96rem;
  height: 96rem;
  pointer-events:none;
  margin-left: -50rem;
  margin-top: -50rem;

  img {
    width: 100%;
  }
}

.start-game {
  text-align: center;
  transform: translateY(-50%);

  button {
    background-color: $color-yellow;

    &:hover {
      background-color: lighten($color-yellow, 5%);
    }
  }
}
</style>
